export default (state = null, action) => {
    if ('SETUP_DEVICE_KEY' === action.type) {
        return action.payload;
    }

    return state;
}
